import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import PrivateRoute from './PrivateRoutes';
import MetricsForm from './components/MetricsForm';
import Login from './components/Login';
import NotFound from './NotFound';
import BrazilMap from './components/BrazilMap';
import GeneralData from './components/GeneralTakeatInformations';
import Sucesso from './components/Sucesso';
import Header from './components/Header'; // 🔹 Importa o novo Header

function App() {
  const token = localStorage.getItem('authToken');

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    window.location.href = "/login"; // Redireciona para login
  };

  return (
    <AuthProvider>
      <Router>
        {token && (<Header handleLogout={handleLogout} />)} {/* 🔹 Agora o Header está global */}
        <div> {/* 🔹 Adiciona espaço abaixo do header */}
          <Routes>
            <Route path="/" element={token ? <GeneralData /> : <Login />} />
            <Route path="/login" element={<Login />} />
            <Route 
              path="/panel" 
              element={
                <PrivateRoute>  
                  <MetricsForm /> 
                </PrivateRoute>
              } 
            />
            <Route path="*" element={<NotFound />} />
            <Route path="/general" element={<PrivateRoute><GeneralData /></PrivateRoute>} />
            <Route path="/sucesso" element={<PrivateRoute><Sucesso /></PrivateRoute>} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
